import React, { useEffect } from 'react';
import { logSessionInfo } from '../../../../../services/logger';
import './CheckHeadsetView.scss';

export default function CheckHeadsetView(props) {

  const { goToListenToRecording, goToTestMicrophone, asrCopy, speechProps } = props
  useEffect(() => {
    speechProps.speakWithPromise({ textToSpeak: asrCopy.teacher_mode_asr_mic_check });
    return () => {
      speechProps.abortSpeech();
    }
  }, []);

    return (
      <div className="check-headset-view">
        <div className="check-headset-view__content">
          <div className="check-headset-view__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 64 64" fill="none">
              <path d="M32.0004 2.46155C37.763 2.46161 43.2987 4.70705 47.433 8.72139C51.5673 12.7357 53.9747 18.203 54.1444 23.9631L54.1542 24.6154C56.1128 24.6154 57.9911 25.3934 59.3759 26.7783C60.7608 28.1632 61.5388 30.0415 61.5388 32V36.9231C61.5388 38.8816 60.7608 40.7599 59.3759 42.1448C57.9911 43.5297 56.1128 44.3077 54.1542 44.3077L53.4404 44.3102C52.4679 47.5602 50.559 50.4515 47.9523 52.6226C45.3456 54.7937 42.1567 56.1483 38.7844 56.5169C38.2591 57.476 37.4296 58.233 36.4266 58.6686C35.4236 59.1043 34.3041 59.1937 33.2447 58.9229C32.1852 58.6522 31.246 58.0365 30.575 57.173C29.9041 56.3096 29.5395 55.2474 29.5388 54.1539C29.5381 53.0818 29.8874 52.0388 30.5336 51.1834C31.1798 50.3279 32.0875 49.7068 33.1189 49.4143C34.1503 49.1219 35.249 49.1741 36.248 49.563C37.247 49.952 38.0918 50.6564 38.6539 51.5692C40.7685 51.2696 42.7687 50.4248 44.4579 49.118C46.1471 47.8111 47.4672 46.0872 48.2884 44.1157C47.8385 43.9309 47.4538 43.6164 47.1833 43.2122C46.9129 42.8081 46.7688 42.3325 46.7696 41.8462V27.0769C46.7696 26.4241 47.0289 25.798 47.4906 25.3364C47.9522 24.8747 48.5783 24.6154 49.2312 24.6154C49.2334 20.0952 47.4593 15.7552 44.2913 12.5309C41.1234 9.30659 36.8153 7.45625 32.2958 7.37875C27.7763 7.30125 23.4073 9.0028 20.1307 12.1166C16.8541 15.2304 14.9322 19.507 14.7795 24.0246L14.7696 24.6154C15.4224 24.6154 16.0486 24.8747 16.5102 25.3364C16.9718 25.798 17.2311 26.4241 17.2311 27.0769V41.8462C17.2311 42.499 16.9718 43.1251 16.5102 43.5867C16.0486 44.0484 15.4224 44.3077 14.7696 44.3077H9.84653C7.88801 44.3077 6.0097 43.5297 4.62482 42.1448C3.23993 40.7599 2.46191 38.8816 2.46191 36.9231V32C2.46191 30.0415 3.23993 28.1632 4.62482 26.7783C6.0097 25.3934 7.88801 24.6154 9.84653 24.6154C9.84653 18.7398 12.1806 13.1049 16.3352 8.95026C20.4899 4.79561 26.1248 2.46155 32.0004 2.46155Z" fill="#3E83BE"/>
            </svg>
            <div className="check-headset-view__header-text">
              <div className="check-headset-view__title">
                CHECK AUDIO INPUT
              </div>
            </div>
          </div>
          
          <div className="check-headset-view__tips-container">
            <ul className="check-headset-view__tips-list">
              <li className="check-headset-view__tips-item">• Check that the device or headset is not muted</li>
              <li className="check-headset-view__tips-item">• Set the device input volume to about 50%</li>
              <li className="check-headset-view__tips-item">• Confirm the correct microphone is enabled</li>
            </ul>
          </div>
        </div>
        
        <div className="check-headset-view__button-container">
          <button 
            className="check-headset-view__button secondary"
            onClick={goToListenToRecording}
          >
            Back
          </button>
          <button 
            className="check-headset-view__button"
            onClick={goToTestMicrophone}
          >
            Next
          </button>
        </div>
      </div>
    )
} 